module.exports = __webpack_public_path__ + "img/NYCEDC.08c13505.png";